import {
  Box,
  IconButton,
  Tooltip,
  useTheme,
} from '@mui/material';

import {
  DarkModeOutlined,
  LightModeOutlined,
  NotificationsOutlined,
  SettingsOutlined,
} from '@mui/icons-material';

import {
  useContext,
} from 'react';

import {
  ColorModeContext,
} from '../../../theme';

import AccountMenu from '../../shared/AccountMenu';


const Topbar = () => {
  const theme =
    useTheme();

  const colorMode =
    useContext(
      ColorModeContext
    );


  return (
    <Box
      display="flex"
      justifyContent="flex-end"
      alignItems="center"
      width="100%"
      px={{
        xs: 1.5,
        sm: 3,
        md: 4,
      }}
      py={{
        xs: 1.5,
        sm: 2,
      }}
    >
      <Box
        display="flex"
        alignItems="center"
        gap={{
          xs: 0,
          sm: 0.5,
        }}
      >
        {/* THEME */}

        <Tooltip
          title="Toggle theme"
        >
          <IconButton
            onClick={
              colorMode.toggleColorMode
            }
          >
            {theme.palette.mode ===
              'dark' ? (
              <DarkModeOutlined />
            ) : (
              <LightModeOutlined />
            )}
          </IconButton>
        </Tooltip>


        {/* NOTIFICATIONS */}

        <Tooltip
          title="Notifications"
        >
          <IconButton>
            <NotificationsOutlined />
          </IconButton>
        </Tooltip>


        {/* SETTINGS */}

        <Tooltip
          title="Settings"
        >
          <IconButton>
            <SettingsOutlined />
          </IconButton>
        </Tooltip>


        {/*
         * SAME account menu used by
         * the public Navbar.
         *
         * This now provides:
         *
         * - View Profile
         * - My Orders
         * - ATG Console
         * - Manage Orders (Admin)
         * - Sign Out
         */}
        <AccountMenu
          dashboardSide
        />
      </Box>
    </Box>
  );
};


export default Topbar;